import { render, staticRenderFns } from "./oldCustomerImg.vue?vue&type=template&id=01b55419&"
import script from "./oldCustomerImg.vue?vue&type=script&lang=js&"
export * from "./oldCustomerImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports